import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PublishConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  patientCount: number;
  isLoading?: boolean;
}

export const PublishConfirmationModal: React.FC<
  PublishConfirmationModalProps
> = ({ open, onClose, onConfirm, patientCount, isLoading = false }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      aria-labelledby="publish-confirmation-dialog-title"
    >
      <DialogTitle id="publish-confirmation-dialog-title">
        {t('pages.studies.publish.confirmationTitle')}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="body1">
            {t('pages.studies.publish.confirmationMessage', {
              count: patientCount,
            })}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isLoading}
          color="secondary"
        >
          {t('pages.studies.publish.cancelButton')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={isLoading}
          autoFocus
        >
          {t('pages.studies.publish.confirmButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
